import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  link: {
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 230,
  },
  campaignControl: {
    margin: theme.spacing(1),
    minWidth: 290,
  },
  dateFormControl : {
    maxWidth:170,
    marginRight:8,
    marginTop:-8
  },
  mainChartHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.only("xs")]: {
      flexWrap: "wrap",
    },
  },
  mainChartHeaderRight: {
    width: "100%",
    display: "flex",
    alignItems: "right",
    justifyContent: "space-between",
  },
  mainChartBody: {
    overflowX: "auto"
  },
}));